import React from 'react';

function BlockH() {
  const inputItemsData = [
    {
      slNo: 1,
      item: 'Woven chenille fabrics of MMF for drapery',
      itemCode: '2682002',
      unit: 'Metre',
      quantityConsumed: '',
      purchaseValue: '',
      ratePerUnit: ''
    },
    {
      slNo: 2,
      item: '',
      itemCode: '',
      unit: '',
      quantityConsumed: '',
      purchaseValue: '',
      ratePerUnit: ''
    },
    {
      slNo: 3,
      item: '',
      itemCode: '',
      unit: '',
      quantityConsumed: '',
      purchaseValue: '',
      ratePerUnit: ''
    },
    {
      slNo: 4,
      item: '',
      itemCode: '',
      unit: '',
      quantityConsumed: '',
      purchaseValue: '',
      ratePerUnit: ''
    },
    {
      slNo: 5,
      item: '',
      itemCode: '',
      unit: '',
      quantityConsumed: '',
      purchaseValue: '',
      ratePerUnit: ''
    },
    {
      slNo: 6,
      item: '',
      itemCode: '',
      unit: '',
      quantityConsumed: '',
      purchaseValue: '',
      ratePerUnit: ''
    },
    {
      slNo: 7,
      item: '',
      itemCode: '',
      unit: '',
      quantityConsumed: '',
      purchaseValue: '',
      ratePerUnit: ''
    },
    {
      slNo: 8,
      item: '',
      itemCode: '',
      unit: '',
      quantityConsumed: '',
      purchaseValue: '',
      ratePerUnit: ''
    },
    {
      slNo: 9,
      item: '',
      itemCode: '',
      unit: '',
      quantityConsumed: '',
      purchaseValue: '',
      ratePerUnit: ''
    },
    {
      slNo: 10,
      item: '',
      itemCode: '',
      unit: '',
      quantityConsumed: '',
      purchaseValue: '',
      ratePerUnit: ''
    },
    {
      slNo: 11,
      item: 'Other Basic Items (indigenous)',
      itemCode: '9920100',
      unit: 'X',
      quantityConsumed: '',
      purchaseValue: '',
      ratePerUnit: ''
    },
    {
      slNo: 12,
      item: 'Total Basic Items (1 to 11)',
      itemCode: '9990100',
      unit: 'X',
      quantityConsumed: '',
      purchaseValue: 0,
      ratePerUnit: ''
    },
    {
      slNo: 13,
      item: 'Non-Basic Chemicals-All Kinds',
      itemCode: '9920300',
      unit: 'X',
      quantityConsumed: '',
      purchaseValue: '',
      ratePerUnit: ''
    },
    {
      slNo: 14,
      item: 'Packing Items',
      itemCode: '9990800',
      unit: 'X',
      quantityConsumed: '',
      purchaseValue: 0,
      ratePerUnit: ''
    },
    {
      slNo: 15,
      item: 'Electricity Own Generated',
      itemCode: '9990400',
      unit: 'KWH',
      quantityConsumed: '',
      purchaseValue: 0,
      ratePerUnit: ''
    },
    {
      slNo: 16,
      item: 'Electricity Purchased and Consumed',
      itemCode: '9990500',
      unit: 'KWH',
      quantityConsumed: '',
      purchaseValue: 0,
      ratePerUnit: ''
    },
    {
      slNo: 17,
      item: 'Petrol, Diesel, Oil, Lubricants Consumed',
      itemCode: '9990600',
      unit: 'X',
      quantityConsumed: '',
      purchaseValue: 0,
      ratePerUnit: ''
    },
    {
      slNo: 18,
      item: 'Coal Consumed',
      itemCode: '9990700',
      unit: 'Tonne',
      quantityConsumed: '',
      purchaseValue: 0,
      ratePerUnit: ''
    },
    {
      slNo: 19,
      item: 'Gas Consumed',
      itemCode: '9990900',
      unit: 'KG',
      quantityConsumed: '',
      purchaseValue: 0,
      ratePerUnit: ''
    },
    {
      slNo: 20,
      item: 'Other Fuel Consumed',
      itemCode: '9920400',
      unit: 'X',
      quantityConsumed: '',
      purchaseValue: 0,
      ratePerUnit: ''
    },
    {
      slNo: 21,
      item: 'Consumable Store',
      itemCode: '9922000',
      unit: 'X',
      quantityConsumed: '',
      purchaseValue: 0,
      ratePerUnit: ''
    },
    {
      slNo: 22,
      item: 'Total Non-Basic Items (13 to 21)',
      itemCode: '9992000',
      unit: 'X',
      quantityConsumed: '',
      purchaseValue: 0,
      ratePerUnit: ''
    },
    {
      slNo: 23,
      item: 'Total Input (12+22)',
      itemCode: '9993000',
      unit: 'X',
      quantityConsumed: '',
      purchaseValue: 0,
      ratePerUnit: ''
    },
    {
      slNo: 24,
      item: 'Any additional requirement of electricity (unmet demand)',
      itemCode: '9999999',
      unit: 'KWH',
      quantityConsumed: '',
      purchaseValue: 0,
      ratePerUnit: ''
    }
  ];

  const formatNumber = (num) => {
    if (num === '' || num === null || num === undefined) return '';
    return num.toLocaleString();
  };

  return (
    <>
      <style>
        {`
          .block-h-header {
            background-color: #e3f2fd;
            padding: 15px 20px;
            border-bottom: 2px solid #1976d2;
            margin-bottom: 20px;
          }
          .page-title {
            color: #1976d2;
            font-size: 24px;
            font-weight: bold;
            margin: 0;
          }
          .reference-numbers {
            color: #333;
            font-size: 14px;
            font-weight: 500;
            margin: 0;
          }
          .input-items-table {
            background-color: #fff;
            border: 1px solid #ddd;
            border-radius: 6px;
            overflow: hidden;
            margin-bottom: 20px;
          }
          .table-header {
            background-color: #f8f9fa;
            border-bottom: 2px solid #1976d2;
          }
          .table th {
            background-color: #e3f2fd;
            color: #1976d2;
            font-weight: 600;
            font-size: 12px;
            text-align: center;
            vertical-align: middle;
            padding: 10px 4px;
            border: 1px solid #dee2e6;
          }
          .table td {
            font-size: 12px;
            text-align: center;
            vertical-align: middle;
            padding: 8px 4px;
            border: 1px solid #dee2e6;
          }
          .table td:first-child {
            text-align: center;
            font-weight: 600;
            width: 60px;
          }
          .table td:nth-child(2) {
            text-align: left;
            font-weight: 500;
            min-width: 250px;
          }
          .table td:nth-child(3) {
            text-align: center;
            font-weight: 500;
            width: 100px;
          }
          .table td:nth-child(4) {
            text-align: center;
            font-weight: 500;
            width: 80px;
          }
          .table td:nth-child(5) {
            text-align: right;
            font-weight: 500;
            width: 100px;
          }
          .table td:nth-child(6) {
            text-align: right;
            font-weight: 500;
            width: 100px;
          }
          .table td:nth-child(7) {
            text-align: right;
            font-weight: 500;
            width: 100px;
          }
          .total-row {
            background-color: #f8f9fa;
            font-weight: 600;
          }
          .footnote {
            font-size: 11px;
            color: #666;
            font-style: italic;
            margin-top: 10px;
          }
        `}
      </style>
      <div className="container-fluid py-3">
        {/* Header Section */}
        <div className="block-h-header">
          <div className="row align-items-center">
            <div className="col-md-6">
              <h1 className="page-title">H: INPUT ITEMS - indigenous items consumed</h1>
            </div>
            <div className="col-md-6 text-end">
              <p className="reference-numbers">DSL No : 404936</p>
              <p className="reference-numbers">PSL No : 31186</p>
            </div>
          </div>
        </div>

        {/* Input Items Table */}
        <div className="input-items-table">
          <div className="table-responsive">
            <table className="table table-bordered mb-0">
              <thead className="table-header">
                <tr>
                  <th>Sl. No.</th>
                  <th>Items</th>
                  <th>Item code (NPC-MS)*</th>
                  <th>Unit of Quantity</th>
                  <th>Quantity Consumed</th>
                  <th>Purchase Value</th>
                  <th>Rate per unit (in Rs.)</th>
                </tr>
              </thead>
              <tbody>
                {inputItemsData.map((row, index) => (
                  <tr key={index} className={row.slNo === 12 || row.slNo === 22 || row.slNo === 23 ? 'total-row' : ''}>
                    <td>{row.slNo}</td>
                    <td>{row.item}</td>
                    <td>{row.itemCode}</td>
                    <td>{row.unit}</td>
                    <td>{row.quantityConsumed}</td>
                    <td>{formatNumber(row.purchaseValue)}</td>
                    <td>{row.ratePerUnit}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Footnote */}
        <div className="footnote">
          * Full description of items not in NPC-MS 2011
        </div>

        {/* Action Buttons */}
        <div className="row mt-4">
          <div className="col-12">
            <hr />
          </div>
          <div className="col-md-8 text-center text-md-start mb-3 mb-md-0">
            <button type="button" className="btn btn_orange mx-1">
              Print  
              <i className="fa fa-print ms-1"></i>
            </button>
            <button type="button" className="btn btn_orange mx-1">
              Save
            </button>
            <button type="reset" className="btn btn_orange mx-1">
              Reset
            </button>
            <button type="button" className="btn btn_orange mx-1">
              Cancel
            </button>
          </div>
          <div className="col-md-4 text-center text-md-end">
            <button type="button" className="btn btn_orange mx-1">
              Back 
              <i className="fa fa-angle-left ms-1"></i>
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default BlockH; 